import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TranslationLanguageEntity } from './translation-language.entity';

@Index('token-language-unique', ['fkTranslationLanguageId', 'token'], {
	unique: true,
})
@Entity('_translation')
export class TranslationEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__translation_language__id',
		nullable: true,
		unsigned: true,
	})
	public fkTranslationLanguageId!: number | null;

	@Column('varchar', { name: '_token', nullable: true, length: 255 })
	public token!: string | null;

	@Column('text', { name: '_translation', nullable: true })
	public translation!: string | null;

	@ManyToOne(
		() => TranslationLanguageEntity,
		(translationLanguage) => translationLanguage.translations,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__translation_language__id', referencedColumnName: 'id' },
	])
	public fkTranslationLanguage!: TranslationLanguageEntity;
}
